import React, { useState } from 'react';
import { observer } from 'mobx-react';

import classes from './AutomatedBillingPaymentStep.module.scss';
import {
  CoachSeatsWidget,
  FeeModuleWidget,
  FreeAccessWidget,
  SetupEntitySubscriptionTable,
  SubscriptionSettingsWidget,
  TaxWidget,
} from '../../../../../../payment';
import { ButtonsRow } from '../../../components/ButtonsRow/ButtonsRow';
import { setupEntityStore } from '../../../../../stores/setupEntityStore';

const AutomatedBillingPaymentStep = observer(() => {
  const [isFeeModuleCreated, setIsFeeModuleCreated] = useState(false);
  const [isSubscriptionSettingsCreated, setIsSubscriptionSettingsCreated] =
    useState(false);
  const [isCoachSeatsCreated, setIsCoachSeatsCreated] = useState(false);

  const { entityId, entityType, stepperMethods } = setupEntityStore;
  const { goToNextStep } = stepperMethods;

  if (!entityId || !entityType) {
    throw new Error('Entity id, entity type or billing type is not defined');
  }

  const isNextBtnDisabled =
    !isSubscriptionSettingsCreated || !isFeeModuleCreated || !isCoachSeatsCreated;

  return (
    <div>
      <div className={classes.row}>
        <div className={classes.column}>
          <FeeModuleWidget
            entityType={entityType}
            className={classes.moduleFormBlock}
            entityId={entityId}
            onSuccessSubmit={() => {
              setIsFeeModuleCreated(true);
            }}
          />
          <TaxWidget entityId={entityId} />
        </div>
        <SubscriptionSettingsWidget
          entityId={entityId}
          defaultMode="EDIT"
          onSuccessSubmit={() => {
            setIsSubscriptionSettingsCreated(true);
          }}
        />
      </div>
      <CoachSeatsWidget
        entityId={entityId}
        mode="CREATE"
        onSuccessSubmit={() => {
          setIsCoachSeatsCreated(true);
        }}
      />

      <SetupEntitySubscriptionTable entityId={entityId} />
      <FreeAccessWidget entityId={entityId} />
      <ButtonsRow onNext={goToNextStep} yesDisabled={isNextBtnDisabled} />
    </div>
  );
});

export { AutomatedBillingPaymentStep };
